/**
 * @generated SignedSource<<fa61a46d5df3a29d780b37f5aa8f022c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleListItemMonthlyRange_routineOccasion$data = {
  readonly deadlineAt: string | null;
  readonly startAt: string;
  readonly " $fragmentType": "TeamScheduleListItemMonthlyRange_routineOccasion";
};
export type TeamScheduleListItemMonthlyRange_routineOccasion$key = {
  readonly " $data"?: TeamScheduleListItemMonthlyRange_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItemMonthlyRange_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleListItemMonthlyRange_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineAt",
      "storageKey": null
    }
  ],
  "type": "ScheduledOccasion",
  "abstractKey": "__isScheduledOccasion"
};

(node as any).hash = "1dcf0427601cded37e331ef64cea62fe";

export default node;
